
import rocket from '../assets/images/rocket.svg';

import smoke from '../assets/images/smoke.png';
import pattern from '../assets/images/pattern-bg.webp';
import { Container, Button } from 'react-bootstrap';
import ScrollingCards from '../components/scrolling-cards';
import star from '../assets/images/star.svg';
// import Capabilities from '../components/capabilities';
import HeroMarquee from '../components/hero-marquee';
import Testimonials from '../components/testimonials';
import OurWorks from '../components/our-works';
import { useNavigate } from 'react-router-dom';

import { useEffect, useRef, useState } from 'react';

import saturn from '../assets/images/saturn.svg';
import gallaxy from '../assets/images/gallaxy.svg';

import rocketIcon from '../assets/images/rocket-icon.svg';
import moon from '../assets/images/moon.svg';

import sun from '../assets/images/sun.svg';
import atoms from '../assets/images/atoms.svg';

const Home = () => {
    const [rocketY, setRocketY] = useState(0);
    const [isLaunching, setIsLaunching] = useState(false);
    const [isResetting, setIsResetting] = useState(false);
    const ticking = useRef(false);
    const launchTimeout = useRef(null);
    const navigate = useNavigate();

    // Scroll animation (disabled during launch)
    useEffect(() => {
        if (isLaunching) return;
        const handleScroll = () => {
            if (!ticking.current) {
                window.requestAnimationFrame(() => {
                    const scrollY = window.scrollY;
                    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
                    const progress = docHeight > 0 ? Math.min(scrollY / docHeight, 1) : 0;
                    setRocketY(progress * -150);
                    ticking.current = false;
                });
                ticking.current = true;
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isLaunching]);

    // Launch handler

    const handleLaunch = () => {
        if (isLaunching || isResetting) return;
        setIsLaunching(true);
        setRocketY(-window.innerHeight - 200); // fly out of view
        launchTimeout.current = setTimeout(() => {
            navigate(`/contact-us`);
            setIsLaunching(false);
            setIsResetting(true);

            // Instantly move rocket below, then animate up
            // setRocketY(window.innerHeight + 200);


            requestAnimationFrame(() => {
                setTimeout(() => {
                    setRocketY(0); // animate up to original (bottom to top only)
                    setTimeout(() => setIsResetting(false), 500);
                }, 30);
            });
        }, 1200);
    };

    // Cleanup timeout on unmount
    useEffect(() => () => clearTimeout(launchTimeout.current), []);

    return (
        <div className="page-wrapper">
            <div className="hero-section" style={{ backgroundImage: `url(${pattern}` }}>
                <div className="pattern-section" style={{ backgroundImage: `url(${smoke}` }}>
                    <div className="overlay">
                        <Container>
                            <div className="hero-content">
                                <span className='hero-sub-title'>We’re AdRocket</span>
                                <h1 className='hero-title'>Launch Your Growth</h1>
                                <p>
                                    A quirky, energetic digital marketing crew that mixes creativity, strategy and unapologetic performance to help brands scale faster.
                                </p>
                                <Button variant="theme" className={`btn-rounded small mt-4 mb-3`} onClick={handleLaunch} disabled={isLaunching}>
                                    <span className="fs-14 fw-500">Launch</span>
                                    <span className="arrow-icon">
                                        <i className="fa-regular fa-paper-plane icon"></i>
                                        <i className="fa-regular fa-paper-plane icon"></i>
                                    </span>
                                </Button>
                            </div>
                        </Container>

                        <img
                            src={rocket}
                            alt="rocket"
                            className="rocket-image"
                            style={{
                                transform: `translateY(${rocketY}px)`,
                                transition:
                                    isLaunching
                                        ? 'transform 2.5s cubic-bezier(.4,2,.3,1)'
                                        : isResetting
                                            ? 'transform 0.5s cubic-bezier(.4,2,.3,1)'
                                            : 'transform 0.4s cubic-bezier(.4,2,.3,1)'
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Hero Marquee */}
            <HeroMarquee />


            {/* Scrolling Gallery */}
            <div className="scrolling-gallery-section position-relative">
                <img src={gallaxy} alt='floating-icons' className='floating-icons left d-none d-md-block z-1' />
                <img src={saturn} alt='floating-icons' className='floating-icons right' />
                <div className="text-center mt-5 pt-5">
                    <span className='hero-sub-title'>What We Do</span>
                    <h1 className='hero-title mb-0 outline-text'>The Fuel We Run On</h1>
                </div>
            </div>
            <ScrollingCards />

            <hr />


            <Container fluid>
                <div className="main-marq xlrg with-shad">
                    <div className="scrolling-gallery-section">
                        {/* <div className="text-center mb-5">
                            <span className='hero-sub-title'>We are Adrocket</span>
                            <h1 className='hero-title mb-0 outline-text'>Why Brands Choose Us</h1>
                        </div> */}
                    </div>


                    <div className="slide-har st1 opacity-5">
                        <div className="box d-flex align-items-center">
                            <div className="item">
                                <h4>Young brains</h4>
                            </div>
                            <div className="item">
                                <div className="w-70px">
                                    <img src={star} alt="" />
                                </div>
                            </div>

                            <div className="item">
                                <h4>sharp strategies</h4>
                            </div>
                            <div className="item">
                                <div className="w-70px">
                                    <img src={star} alt="" />
                                </div>
                            </div>

                            <div className="item">
                                <h4>Creative storytelling meets data science</h4>
                            </div>
                            <div className="item">
                                <div className="w-70px">
                                    <img src={star} alt="" />
                                </div>
                            </div>
                            <div className="item">
                                <h4>Fast execution & fast growth</h4>
                            </div>
                            <div className="item">
                                <div className="w-70px">
                                    <img src={star} alt="" />
                                </div>
                            </div>
                            <div className="item">
                                <h4>Transparent results, no fluff</h4>
                            </div>
                            <div className="item">
                                <div className="w-70px">
                                    <img src={star} alt="" />
                                </div>
                            </div>
                            <div className="item">
                                <h4>A team obsessed with KPIs</h4>
                            </div>
                            <div className="item">
                                <div className="w-70px">
                                    <img src={star} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>


            <Container fluid className='mt-5 py-md-5 position-relative'>
                <img src={rocketIcon} alt='floating-icons' className='floating-icons left top' />
                <img src={moon} alt='floating-icons' className='floating-icons right bottom' />

                <div className="text-center">
                    <span className='hero-sub-title'>Case Highlights</span>
                    <h1 className='hero-title mb-5 outline-text'>Our Work That Lifted Off</h1>
                </div>
                {/* <Capabilities /> */}
                <OurWorks />
            </Container>


            <div className='position-relative'>
                <img src={sun} alt='floating-icons' className='floating-icons left top' style={{top: "300px"}} />
                <img src={atoms} alt='floating-icons' className='floating-icons right bottom rotate' />

                <Container className='my-5 py-5'>
                    {/* Testimonials Section */}
                    <Testimonials />
                </Container>
            </div>




        </div>
    )
};

export default Home;